import React from 'react';

function ProjectCard({ title, bannerText, date, tags, colorClass, gradientClass, icon, image, onClick, badge }) {
    return (
        <div
            onClick={onClick}
            className="group cursor-pointer bg-white dark:bg-[#1a2130] rounded-xl border border-slate-200 dark:border-[#232f48] overflow-hidden hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10 transition-all duration-300 flex flex-col aspect-square relative"
        >
            {/* Banner/Icon Area */}
            <div className="flex-1 bg-slate-300 flex flex-col gap-3 items-center justify-center p-4 transition-all duration-300 group-hover:scale-105 w-full">

                {/* Icon/Image Container */}
                {image ? (
                    <img src={image} alt={title} className="h-16 w-auto object-contain max-w-[80%] drop-shadow-md mb-2" />
                ) : (
                    icon && (
                        <span className={`material-symbols-outlined text-6xl ${colorClass} drop-shadow-sm mb-2`}>
                            {icon}
                        </span>
                    )
                )}

                <span className="text-xs font-bold uppercase text-slate-900 tracking-wider">
                    {date}
                </span>
            </div>

            {badge && (
                <div className="absolute top-3 right-3 z-10 bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border border-slate-200 dark:border-slate-700 shadow-sm text-slate-500 dark:text-slate-400">
                    {badge}
                </div>
            )}

            {/* Minimal Info Footer */}
            <div className="w-full h-14 md:h-auto md:min-h-[4rem] px-3 md:px-4 md:py-4 bg-white dark:bg-[#1a2130] border-t border-slate-100 dark:border-slate-800 z-10 relative flex items-center">
                <div className="w-full flex justify-center md:justify-between items-center gap-2">
                    <span className={`${colorClass} text-sm md:text-lg font-black leading-tight tracking-tight line-clamp-2 break-words text-center md:text-left`}>
                        {bannerText || title}
                    </span>
                    <span className="material-symbols-outlined text-sm text-slate-400 group-hover:text-primary transition-colors shrink-0">open_in_new</span>
                </div>
            </div>
        </div>
    );
}

export default ProjectCard;
